// src/pages/About.js
import React, { useState, useEffect } from "react";
import "./About.css";

const About = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAboutPage = async () => {
      try {
        const response = await fetch(
          "https://cms.vxpath.com/wp-json/wp/v2/pages?slug=about"
        );
        if (!response.ok) throw new Error("Failed to fetch About page");
        const pages = await response.json();
        if (pages.length === 0) throw new Error("About page not found");

        const page = pages[0];
        const acf = page.acf || {};

        // Parse lists from text areas
        const expertiseList = acf.expertise_list
          ? acf.expertise_list.split('\n').filter(line => line.trim())
          : [];
        const whyChooseList = acf.why_choose_list
          ? acf.why_choose_list.split('\n').filter(line => line.trim())
          : [];

        setContent({
          title: page.title.rendered,
          subtitle: acf.subtitle || "Designing intelligent, secure, and scalable digital networks",
          mission: acf.mission_text || "",
          expertise: expertiseList,
          whyChoose: whyChooseList,
          vision: acf.vision_text || "",
          stats: {
            uptime: acf.stat_uptime || "99.99%",
            deployments: acf.stat_deployments || "500+",
            pros: acf.stat_pros || "150+",
            industries: acf.stat_industries || "30+",
          }
        });
        setLoading(false);
      } catch (err) {
        console.error("Error fetching About page:", err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchAboutPage();
  }, []);

  if (loading) return <div className="about-page">Loading...</div>;
  if (error) return <div className="about-page">Error: {error}</div>;
  if (!content) return null;

  return (
    <div className="about-page">
      {/* Header */}
      <header className="about-header" aria-labelledby="about-title">
        <div className="about-header-content">
          <h1 id="about-title">{content.title}</h1>
          <p>{content.subtitle}</p>
        </div>
      </header>

      {/* Core Section */}
      <section className="about-container">
        <div className="about-left" aria-labelledby="mission-heading">
          <h2 id="mission-heading">Our Mission</h2>
          <p>{content.mission}</p>

          <h2>Our Expertise</h2>
          {content.expertise.length > 0 ? (
            <ul>
              {content.expertise.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          ) : (
            <p>No expertise items found.</p>
          )}

          <h2>Why Choose Vxpath</h2>
          {content.whyChoose.length > 0 ? (
            <ul>
              {content.whyChoose.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          ) : (
            <p>No reasons found.</p>
          )}
        </div>

        <div className="about-right" role="region" aria-label="Company performance metrics">
          <div className="stat-card">
            <div className="stat-number">{content.stats.uptime}</div>
            <div className="stat-label">Uptime Reliability</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{content.stats.deployments}</div>
            <div className="stat-label">Enterprise Deployments</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{content.stats.pros}</div>
            <div className="stat-label">Certified Professionals</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{content.stats.industries}</div>
            <div className="stat-label">Industries Served</div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="vision-section" aria-labelledby="vision-heading">
        <h2 id="vision-heading">Our Vision</h2>
        <p>{content.vision}</p>
      </section>
    </div>
  );
};

export default About;